export default __webpack_public_path__ + "static/media/book-read-user-primary.129598ea.svg";